<!-- Evaluación Programada -->
<div class="pt-4 border-t border-gray-200 dark:border-gray-700">
  <div class="flex items-center gap-2 mb-3">
    <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Evaluación Programada</h3>
    @if (schedule) {
    <span class="inline-flex items-center px-2 py-0.5 rounded-full text-xs font-medium"
      [ngClass]="schedule.enabled
        ? 'bg-emerald-50 text-emerald-700 dark:bg-emerald-500/10 dark:text-emerald-400'
        : 'bg-gray-100 text-gray-600 dark:bg-gray-700 dark:text-gray-300'">
      {{ schedule.enabled ? 'Activa' : 'Pausada' }}
    </span>
    }
  </div>

  @if (schedule) {
  <div class="grid grid-cols-1 sm:grid-cols-2 gap-5">
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 mt-0.5">
        <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </div>
      <div class="min-w-0 flex-1">
        <p class="text-xs text-gray-500 dark:text-gray-400">Frecuencia</p>
        <p class="text-sm font-medium text-gray-900 dark:text-white">
          {{ getScheduleLabel(schedule) }}
          @if (schedule.frecuency === 'WEEKLY' && schedule.runDays && schedule.runDays.length > 0) {
          <span class="ml-1">({{ formatRunDays(schedule.runDays) }})</span>
          }
          @if (schedule.frecuency === 'MONTHLY' && schedule.runDays && schedule.runDays.length > 0) {
          <span class="ml-1">(días {{ schedule.runDays.join(', ') }})</span>
          }
        </p>
      </div>
    </div>
    @if (schedule.cronExpression) {
    <div class="flex items-start gap-3">
      <div class="flex-shrink-0 mt-0.5">
        <svg class="w-5 h-5 text-gray-400" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10 20l4-16m4 4l4 4-4 4M6 16l-4-4 4-4"/>
        </svg>
      </div>
      <div class="min-w-0 flex-1">
        <p class="text-xs text-gray-500 dark:text-gray-400">Expresión Cron</p>
        <p class="text-sm font-mono text-gray-600 dark:text-gray-300">{{ schedule.cronExpression }}</p>
      </div>
    </div>
    }
  </div>
  } @else {
  <p class="text-sm text-gray-400 dark:text-gray-500">Sin programación configurada.</p>
  }
</div>

<!-- Historial de Evaluaciones -->
@if (schedule?.scheduledJobConfigId) {
<div class="pt-4 border-t border-gray-200 dark:border-gray-700">
  <button type="button" (click)="toggleHistoryPanel()"
    class="w-full flex items-center justify-between mb-3">
    <h3 class="text-xs font-semibold text-gray-500 dark:text-gray-400 uppercase tracking-wide">Historial de Evaluaciones</h3>
    <svg class="w-4 h-4 text-gray-400 transition-transform" [class.rotate-180]="isHistoryOpen"
      fill="none" stroke="currentColor" viewBox="0 0 24 24">
      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
    </svg>
  </button>
  @if (isHistoryOpen) {
  <div>
    @if (isLoadingHistory) {
      <p class="text-xs text-gray-500 dark:text-gray-400 italic py-3">Cargando historial...</p>
    } @else if (executions.length === 0) {
      <p class="text-xs text-gray-500 dark:text-gray-400 italic py-3">Sin ejecuciones registradas todavía.</p>
    } @else {
      <div class="overflow-x-auto rounded-lg border border-gray-200 dark:border-gray-700">
        <table class="min-w-full text-xs">
          <thead class="bg-gray-50 dark:bg-gray-800">
            <tr class="text-left text-gray-500 dark:text-gray-400 uppercase tracking-wider">
              <th class="px-3 py-2 font-semibold">Inicio</th>
              <th class="px-3 py-2 font-semibold">Estado</th>
              <th class="px-3 py-2 font-semibold">Duración</th>
              <th class="px-3 py-2 font-semibold">Origen</th>
              <th class="px-3 py-2 font-semibold">Mensaje</th>
            </tr>
          </thead>
          <tbody class="divide-y divide-gray-200 dark:divide-gray-700 bg-white dark:bg-gray-900">
            @for (ex of executions; track ex.id) {
            <tr class="text-gray-700 dark:text-gray-300">
              <td class="px-3 py-2 whitespace-nowrap">{{ ex.startTime | datetime }}</td>
              <td class="px-3 py-2">
                <span class="inline-flex items-center px-2 py-0.5 rounded-full text-[10px] font-medium"
                  [ngClass]="{
                    'bg-emerald-50 text-emerald-700 dark:bg-emerald-900/30 dark:text-emerald-400': ex.status === 'SUCCESS',
                    'bg-red-50 text-red-700 dark:bg-red-900/30 dark:text-red-400': ex.status === 'FAILED',
                    'bg-amber-50 text-amber-700 dark:bg-amber-900/30 dark:text-amber-400': ex.status === 'RUNNING'
                  }">
                  {{ executionStatusLabel(ex.status) }}
                </span>
              </td>
              <td class="px-3 py-2 whitespace-nowrap">{{ ex.durationMs != null ? (ex.durationMs + ' ms') : '—' }}</td>
              <td class="px-3 py-2">{{ ex.triggeredManually ? 'Manual' : 'Programada' }}</td>
              <td class="px-3 py-2 max-w-xs truncate" [title]="ex.message || ''">{{ ex.message || '—' }}</td>
            </tr>
            }
          </tbody>
        </table>
      </div>
      <div class="flex items-center justify-between mt-3 text-xs text-gray-500 dark:text-gray-400">
        <span>Página {{ historyPage + 1 }} de {{ historyTotalPages || 1 }} · {{ historyTotalElements }} ejecuciones</span>
        <div class="flex gap-2">
          <button (click)="prevHistoryPage()" [disabled]="historyPage === 0 || isLoadingHistory"
            class="px-2.5 py-1 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            Anterior
          </button>
          <button (click)="nextHistoryPage()" [disabled]="historyPage >= historyTotalPages - 1 || isLoadingHistory"
            class="px-2.5 py-1 rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-800 hover:bg-gray-50 dark:hover:bg-gray-700 disabled:opacity-50 disabled:cursor-not-allowed transition-colors">
            Siguiente
          </button>
        </div>
      </div>
    }
  </div>
  }
</div>
}

<!-- Schedule Modal -->
@if (isScheduleModalOpen) {
<div class="fixed inset-0 z-modal-top flex items-center justify-center bg-black/50" (click)="closeScheduleModal()">
  <div class="bg-white dark:bg-gray-900 rounded-2xl shadow-xl w-full max-w-md p-6 mx-4" (click)="$event.stopPropagation()">
    <div class="flex items-center gap-3 mb-6">
      <div class="p-2 bg-brand-50 dark:bg-brand-900/20 rounded-xl">
        <svg class="w-5 h-5 text-brand-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z"/>
        </svg>
      </div>
      <div>
        <h3 class="text-lg font-bold text-gray-900 dark:text-white">{{ schedule ? 'Editar' : 'Programar' }} Evaluación</h3>
        <p class="text-xs text-gray-500 dark:text-gray-400">El segmento se recalculará automáticamente</p>
      </div>
    </div>

    <div class="space-y-5">

      <!-- Frecuencia -->
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Frecuencia</label>
        <div class="grid grid-cols-3 gap-2">
          @for (opt of [
            {value: 'MINUTES', label: 'Minutos'},
            {value: 'HOURLY',  label: 'Por Horas'},
            {value: 'DAILY',   label: 'Diaria'},
            {value: 'WEEKLY',  label: 'Semanal'},
            {value: 'MONTHLY', label: 'Mensual'}
          ]; track opt.value) {
          <button type="button" (click)="scheduleForm.frecuency = $any(opt.value)"
            [ngClass]="scheduleForm.frecuency === opt.value
              ? 'bg-brand-500 text-white border-brand-500'
              : 'bg-white dark:bg-gray-800 text-gray-700 dark:text-gray-300 border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700'"
            class="px-3 py-2.5 text-sm font-medium rounded-xl border transition-colors text-center">
            {{ opt.label }}
          </button>
          }
        </div>
      </div>

      <!-- MINUTES: solo intervalValue -->
      @if (scheduleForm.frecuency === 'MINUTES') {
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Cada cuántos minutos <span class="font-normal text-gray-400">(1–59)</span>
        </label>
        <input type="number" min="1" max="59" [(ngModel)]="scheduleForm.intervalValue"
          class="w-full h-11 px-4 py-2.5 text-sm bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none text-gray-900 dark:text-white transition-colors">
      </div>
      }

      <!-- HOURLY: intervalValue + minuto de la hora -->
      @if (scheduleForm.frecuency === 'HOURLY') {
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Cada cuántas horas <span class="font-normal text-gray-400">(1–23)</span>
        </label>
        <input type="number" min="1" max="23" [(ngModel)]="scheduleForm.intervalValue"
          class="w-full h-11 px-4 py-2.5 text-sm bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none text-gray-900 dark:text-white transition-colors">
      </div>
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Minuto de inicio de la hora
        </label>
        <input type="time" [(ngModel)]="scheduleForm.runTime"
          class="w-full h-11 px-4 py-2.5 text-sm bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none text-gray-900 dark:text-white transition-colors">
      </div>
      }

      <!-- DAILY / WEEKLY / MONTHLY: hora de ejecución -->
      @if (scheduleForm.frecuency === 'DAILY' || scheduleForm.frecuency === 'WEEKLY' || scheduleForm.frecuency === 'MONTHLY') {
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Hora de ejecución</label>
        <input type="time" [(ngModel)]="scheduleForm.runTime"
          class="w-full h-11 px-4 py-2.5 text-sm bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none text-gray-900 dark:text-white transition-colors">
      </div>
      }

      <!-- WEEKLY: días de la semana -->
      @if (scheduleForm.frecuency === 'WEEKLY') {
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">Días de ejecución</label>
        <div class="flex flex-wrap gap-2">
          @for (day of weekDays; track day.value) {
          <button type="button" (click)="toggleRunDay(day.value)"
            [ngClass]="isRunDaySelected(day.value)
              ? 'bg-brand-500 text-white border-brand-500'
              : 'bg-white dark:bg-gray-800 text-gray-600 dark:text-gray-400 border-gray-300 dark:border-gray-600 hover:bg-gray-50 dark:hover:bg-gray-700'"
            class="px-3 py-2 text-xs font-bold rounded-lg border transition-colors min-w-[44px] text-center">
            {{ day.label }}
          </button>
          }
        </div>
      </div>
      }

      <!-- MONTHLY: días del mes -->
      @if (scheduleForm.frecuency === 'MONTHLY') {
      <div>
        <label class="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
          Días del mes <span class="font-normal text-gray-400">(1–31)</span>
        </label>
        <div class="flex gap-2 mb-2">
          <input #monthDayInput type="number" min="1" max="31" placeholder="Ej: 15"
            (keydown.enter)="addMonthDay(monthDayInput)"
            class="flex-1 h-9 px-3 text-sm bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-600 rounded-xl focus:ring-2 focus:ring-brand-500 focus:border-brand-500 outline-none text-gray-900 dark:text-white transition-colors">
          <button type="button" (click)="addMonthDay(monthDayInput)"
            class="px-3 py-1.5 text-sm font-medium text-white bg-brand-500 rounded-xl hover:bg-brand-600 transition-colors">
            Añadir
          </button>
        </div>
        @if (scheduleForm.runDaysMonthly.length > 0) {
        <div class="flex flex-wrap gap-1.5">
          @for (d of scheduleForm.runDaysMonthly; track d) {
          <span class="inline-flex items-center gap-1 px-2.5 py-1 text-xs font-medium bg-brand-50 dark:bg-brand-900/30 text-brand-700 dark:text-brand-300 rounded-lg border border-brand-200 dark:border-brand-800">
            Día {{ d }}
            <button type="button" (click)="removeMonthDay(d)" class="ml-0.5 hover:text-brand-900 dark:hover:text-brand-100">
              <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"/>
              </svg>
            </button>
          </span>
          }
        </div>
        } @else {
        <p class="text-xs text-gray-400 dark:text-gray-500 italic">Añade al menos un día del mes.</p>
        }
      </div>
      }

    </div>

    <div class="flex justify-end gap-3 mt-8">
      <button (click)="closeScheduleModal()"
        class="px-4 py-2.5 text-sm font-medium text-gray-700 dark:text-gray-300 bg-gray-100 dark:bg-gray-800 rounded-xl hover:bg-gray-200 dark:hover:bg-gray-700 transition-colors">
        Cancelar
      </button>
      <button (click)="guardarSchedule()" [disabled]="isSaveDisabled"
        class="inline-flex items-center gap-2 px-4 py-2.5 text-sm font-medium text-white bg-brand-500 rounded-xl hover:bg-brand-600 transition-colors disabled:opacity-50">
        @if (isSavingSchedule) {
          <div class="animate-spin rounded-full h-4 w-4 border-b-2 border-white"></div>
        }
        {{ schedule ? 'Actualizar' : 'Programar' }}
      </button>
    </div>
  </div>
</div>
}
